<div class="modal-header">
  <h5 class="modal-title">Create New {{ title }}</h5>

  <span
    class="fa fa-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></span>
</div>
<div class="modal-body">
  <form [formGroup]="accountForm">
    <div class="form-group">
      <label>Name<span class="required-text">*</span></label>
      <input type="text" formControlName="name" class="form-control" required />
    </div>
    <div class="form-group">
      <label>Phone</label>
      <input type="tel" formControlName="phone" class="form-control" />
    </div>
    <div class="form-group">
      <label>Email</label>
      <input type="text" formControlName="email" class="form-control" />
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!accountForm.valid"
    (click)="saveAccount()"
  >
    Save
  </button>
  <button type="button" class="btn btn-default" (click)="activeModal.close()">
    Cancel
  </button>
</div>
